var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9FAFB",
    strokeWidth: 7.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 32.6005C17.0132 32.6005 15.2 31.2007 15.2 29.1484C15.2 27.096 17.0132 25.4323 19.25 25.4323C19.4021 25.4323 19.5522 25.44 19.7 25.4549V25.4323H19.7557C19.7189 25.1617 19.7 24.8861 19.7 24.6065C19.7 20.9578 22.9235 18 26.9 18C29.5927 18 31.9402 19.3563 33.1752 21.3651C33.477 21.3243 33.7858 21.3032 34.1 21.3032C37.5793 21.3032 40.4 23.8913 40.4 27.0839C40.4 29.7119 38.4886 31.7154 35.8718 32.3758M27.6011 37.6V28.1161M27.6011 28.1161L23.4687 32.0274M27.6011 28.1161L31.7374 32.0274",
    stroke: "#667085",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.30712a0c8301b0c9e89f1004d2281a97.svg";
export { ForwardRef as ReactComponent };